import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ContentUpgrades } from "@swizec/gatsby-theme-course-platform";
export const _frontmatter = {
  "title": "\"silicon valley is like hollywood\"",
  "description": "and I don't mean Silicon Valley the place, I mean Silicon Valley the concept.",
  "published": "2021-01-29T00:00:00.000Z",
  "hero": "./img/swizec-teller-large.jpg",
  "categories": "Opinions, Podcast, Mindset",
  "content_upgrade": "SeniorMindset"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`and I don't mean Silicon Valley the place, I mean Silicon Valley the concept.`}</p>
    <p>{`We talked about this and more with Aderson Oliveira on `}<a parentName="p" {...{
        "href": "https://solocoder.com/podcast/swizec-teller-a-geek-with-a-hat"
      }}>{`a recent episode of The Solo Coder podcast`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "./img/Ep-#74-Swizec-Teller-A-Geek-With-A-Hat-%5BS04-E14%5Di6c1e1.jpeg",
        "alt": "Ep #74: Swizec Teller - A Geek With A Hat [S04-E14]"
      }}></img></p>
    <p>{`Wow I look stoned on that photo. Promise I wasn't! 😅`}</p>
    <p>{`We recorded one of those meandering interviews on the career side of programming.`}</p>
    <p>{`Talked about how I got into coding, immigrating to America, the difference between freelancing, selling products, having a dayjob, and why I got out of the free life for a job.`}</p>
    <p>{`Freelancers don't get visas and the money sloshing around Silicon Valley is `}<em parentName="p">{`ridiculous`}</em>{`. Nobody wants freelancers.`}</p>
    <p><em parentName="p">{`"Can we please hire you full-time?"`}</em>{` asks every client.`}</p>
    <ContentUpgrades.SeniorMindset />
    <p>{`Hiring increases their valuation. Investors use headcount as a proxy for growth. And it shifts your salary from a cost to an investment 😉`}</p>
    <p>{`Don't worry though, everyone follows `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/should-you-work-at-a-startup"
      }}>{`the careerist approach`}</a>{`. You work full-time, play the party line, go rah-rah-rah for the cause.`}</p>
    <p>{`When you've done your thing, you move on to the next gig. You were hired for a specific set of skills and experiences. Afterwards, you can choose to grow with the company (recommended), but no hard feelings if you move on to the next place that needs you. That's how it works.`}</p>
    <p>{`Like when an F1 driver drives Ferrari. They `}<em parentName="p">{`are`}</em>{` Ferrari. Next season they could be Red Bull. Just as committed.`}</p>
    <p>{`That's where I think Silicon Valley (the concept) excels 👉 it's an ecosystem. SFBA happens to be the biggest, but it works anywhere there's a concentration of talent.`}</p>
    <h2 {...{
      "id": "you-build-companies"
    }}>{`You build companies`}</h2>
    <p><em parentName="p">{`Building companies`}</em>{` is an important engineering skill. `}<em parentName="p">{`You`}</em>{` are the difference between a company that can adapt to market demands, and a company that needs 6 months to ship a feature.`}</p>
    <p>{`All because you designed a great system. Or not.`}</p>
    <p>{`And when you can say `}<em parentName="p">{`"Okay you're at this stage, which means you'll hit this problem in 3 months, this team issue tomorrow, and we have to think about so and so in about a year. Here's how I've solved this in the past"`}</em></p>
    <p>{`I mean that's a "Please write a number on your check" kinda skill 😉`}</p>
    <p>{`You should `}<a parentName="p" {...{
        "href": "https://solocoder.com/podcast/swizec-teller-a-geek-with-a-hat"
      }}>{`listen to the podcast episode`}</a>{`.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: I want to create a reverse podcasts this year. Instead of hosting my own, I'd go on other people's and collect those episodes into a curated feed. Got any favorites you listen to? hit reply`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      